import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@shadcn-in-nx/ui/dialog";
import { Button } from "@shadcn-in-nx/ui/button";
import { PartyPopper, Gift } from "lucide-react";

const TOTAL_CREDITS = 73;

export default function OnboardingRewardModal({ open, onOpenChange }) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md text-center">
                <DialogHeader>
                    <DialogTitle className="flex items-center justify-center gap-2 text-xl">
                        <PartyPopper className="w-6 h-6 text-amber-500" />
                        {t("onboarding.allComplete")}
                        <PartyPopper className="w-6 h-6 text-amber-500" />
                    </DialogTitle>
                </DialogHeader>
                <div className="py-6 space-y-4">
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 mx-auto">
                        <Gift className="w-8 h-8 text-white" />
                    </div>
                    <p className="text-muted-foreground">
                        {t("onboarding.allCompleteMessage", {
                            credits: TOTAL_CREDITS,
                        })}
                    </p>
                    <Button
                        onClick={() => {
                            onOpenChange(false);
                            navigate("/invite");
                        }}
                        className="w-full"
                    >
                        {t("onboarding.goToInvite")}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
